import script from "./Company.vue?vue&type=script&setup=true&lang=js"
export * from "./Company.vue?vue&type=script&setup=true&lang=js"

import "./Company.vue?vue&type=style&index=0&id=0cb42003&lang=scss"
import "./Company.vue?vue&type=style&index=1&id=0cb42003&scoped=true&lang=scss"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0cb42003"]])

export default __exports__